import { IUserDetails } from '@src/model/user/UserDetails';
import { IUserSkillEvaluation } from '@src/model/user/UserSkillEvaluation';

export default class UserSkillEvaluationHelperUtils {
  /** Check ownership of evaluation */
  static isUserSkillEvaluationOwner = (skillEvaluation: IUserSkillEvaluation, currentUser: IUserDetails): boolean => {
    return skillEvaluation.evaluatedBy.id === currentUser.id;
  };
}
